import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CombinedCoverImageAndContentComponent} from '@aviary/components/combined-cover-image-and-content/combined-cover-image-and-content.component';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {HoldPositionComponent} from '@app/my-account/holds/hold-position/hold-position.component';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {Hold} from '@store/holds/holds.types';

@Component({
  selector: 'px-hold-detail',
  host: {
    class: 'flex flex-row items-center w-full',
  },
  template: `
    <mx-combined-cover-image-and-content [catalogRecord]="selectors.minimalCatalogRecordFor(hold) | select"
                                         [coverWidthRem]="3.75" [coverHeightRem]="5" class="w-full">
      <div class="text-title-large">{{ selectors.itemTitleFor(hold) | select }}</div>
      <px-hold-position [status]="selectors.statusFor(hold) | select: 'REQUESTED'"
                        [queueIndex]="selectors.queueIndexAsStringFor(hold) | select: ''"
                        [copiesCount]="selectors.circulatingCopiesFor(hold) | select: 0"/>
      <div>{{ selectors.materialTypeDescriptionFor(hold) | select }}</div>
      <div>{{ selectors.pickupBranchNameFor(hold) | select }}</div>
      <div>Expires: {{ selectors.expireDateFor(hold) | select | format: 'DATE_ONLY' }}</div>
    </mx-combined-cover-image-and-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CombinedCoverImageAndContentComponent, FormatPipe, HoldPositionComponent, SelectPipe]
})
export class HoldDetailComponent {
  @Input({required: true}) hold: Hold;
  public readonly selectors = HoldsSelectors.Stateless;
}
